import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Base64ObjectInput, Question, QuestionStatus} from '@cp/model';
import {UPDATE_QUESTION} from '../sharedQueries';

export function useUpdateQuestion() {
  const [updateQuestionMutation, {loading, error}] = useMutation<
    {updateQuestion: Question},
    {
      moduleId: string;
      questionId: string;
      topic?: string;
      difficulty?: number;
      questionText?: string;
      hint?: string;
      options?: string[];
      answer?: string;
      explanation?: string;
      status?: QuestionStatus;
      statusNote?: string;
      image?: Base64ObjectInput | null;
      graphJsonString?: string | null;
      seedQuestionId?: string | null;
    }
  >(UPDATE_QUESTION);

  const updateQuestion = async (
    moduleId: string,
    questionId: string,
    topic?: string,
    difficulty?: number,
    questionText?: string,
    hint?: string,
    options?: string[],
    answer?: string,
    explanation?: string,
    status?: QuestionStatus,
    statusNote?: string,
    image?: Base64ObjectInput | null,
    graphJsonString?: string | null,
    seedQuestionId?: string | null,
  ) => {
    const result = await updateQuestionMutation({
      variables: {
        moduleId,
        questionId,
        topic,
        difficulty,
        questionText,
        hint,
        options,
        answer,
        explanation,
        status,
        statusNote,
        image: image !== undefined ? image : undefined,
        graphJsonString: graphJsonString !== undefined ? graphJsonString : undefined,
        seedQuestionId: seedQuestionId !== undefined ? seedQuestionId : undefined,
      },
    });

    return extractGqlData(result).updateQuestion;
  };

  return {
    updateQuestion,
    loading,
    error,
  };
}
